import { defineRecipe } from '@plurall/elo-v3';

export const backdropRecipe = defineRecipe({
  className: 'global-loader-backdrop',
  base: {
    position: 'fixed',
    inset: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
});

export const contentRecipe = defineRecipe({
  className: 'global-loader-content',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'space.16',
  },
});

export const labelRecipe = defineRecipe({
  className: 'global-loader-label',
  base: {
    margin: 0,
    fontSize: 'font-size-large',
    color: 'foreground.always.light',
  },
});
